import React from 'react'
import Slider from 'react-slick'
import { get } from 'lodash'
import { Col, Container, Row } from 'react-bootstrap'
import ReactHTMLParser from 'react-html-parser'
import { userCheckMobileScreen } from 'helpers/tools'
import Image from 'components/atoms/Image'
import Typography from 'components/atoms/Typography/Typography'
import SectionTitle from 'components/molecules/SectionTitle'

// Styles
import 'slick-carousel/slick/slick.css'
import './TextCarouselWithImage.scss'

function TextCarouselWithImage({ data }) {
  const isMobile = userCheckMobileScreen()
  const themeClasses = get(data, 'theme.entity.classes')
  const setting = {
    dots: false,
    dotsClass: 'slick-dots primary',
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  return (
    <Container fluid className={`carousel-text-image ${themeClasses} p-lg-5 pt-4 px-4`}>
      <Container>
        <Row>
          <Col lg={4}>
            <Image
              className="carousel-text-image__picture mb-4"
              src={isMobile ? get(data, 'media.entity.images.medium.url') : get(data, 'media.entity.images.wide.url')}
              alt={get(data, 'media.entity.images.alt')}
            />
          </Col>
          <Col lg={{ span: 7, offset: 1 }} className="d-flex flex-column justify-content-center">
            <Slider {...setting}>
              {get(data, 'items').map(({ entity }) => {
                const sectionTitle = get(entity, 'sectionTitle')
                return (
                  <div className="carousel-text-image__content" key={get(entity, 'uuid')}>
                    <div className="carousel-text-image__section-title mb-4">
                      {sectionTitle && <SectionTitle title={sectionTitle} textColor="white" />}
                    </div>
                    <Typography className="carousel-text-image__text mb-4" variant="span">
                      {ReactHTMLParser(get(entity, 'description.value'))}
                    </Typography>
                    <Typography className="carousel-text-image__text">{get(entity, 'title')}</Typography>
                  </div>
                )
              })}
            </Slider>
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default TextCarouselWithImage
